<template>
  <teleport
    v-if="isMounted && toastNotifications?.length"
    to="body"
  >
    <component-wrapper
      :class="{
        'toast-notification-fi': true,
        'toast-notification-fi--offset-top-large': isSnackbarVisible,
        'toast-notification-fi--app-view': fischer.app.isAppView(),
        ...headerHeightClasses,
      }"
    >
      <grid-container-fi>
        <toast-notification-item-fi
          v-for="toast in toastNotifications"
          :key="toast.name"
          :toast="toast"
        />
      </grid-container-fi>
    </component-wrapper>
  </teleport>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import ToastNotificationItemFi from '@/components/notifications-fi/toast-notification-fi/toast-notification-item-fi/ToastNotificationItemFi.vue';
import { useFischer } from '@/composables/fischerPlugin';
import { useHeaderHeight } from '@/composables/headerHeight';
import { useNotificationStore } from '@/store/pinia/notification';

defineOptions({
  name: 'ToastNotificationFi',
});

/**
 * Gate the teleport on mount, never on `!IS_SSR`: that is false on the server but already true in
 * the client's *first* render, which is the hydration pass. The server cannot render a teleport
 * here at all, so anything that puts a toast in the store before this mounts makes Vue hydrate a
 * `Teleport to="body"` against the sibling `.jss-component` islands and takes the whole header
 * apart. A mount gate keeps the first client render identical to the server's whatever the store
 * holds, and lets the teleport appear afterwards as an ordinary patch.
 */
const isMounted = ref(false);
onMounted(() => {
  isMounted.value = true;
});

const { headerHeightClasses } = useHeaderHeight();
const { snackbarVisible: isSnackbarVisible, toastNotifications } =
  storeToRefs(useNotificationStore());
const fischer = useFischer();
</script>

<style src="./toast-notification-fi" />
